/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_Team_DescInputs */



/**
* | output |
* | --- |
* | "A small group of colleagues." |
*
* @param {Meetings_Kind_Team_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_team_desc = /** @type {((inputs?: Meetings_Kind_Team_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_Team_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een kleine groep collega's.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un petit groupe de collègues.")
	return /** @type {LocalizedString} */ ("A small group of colleagues.")
});